export { registerTouchInteractions } from "./registerTouchInteractions";
